import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRightIcon, SparklesIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/salesContent';
import { trackInitiateCheckout } from '../utils/metaPixel';
type CtaButtonProps = {
  children: React.ReactNode;
  note?: string;
  pulse?: boolean;
  /** When set, the button scrolls to this section instead of going to checkout. */
  scrollToId?: string;
};
export function CtaButton({
  children,
  note,
  pulse = true,
  scrollToId
}: CtaButtonProps) {
  const reduceMotion = useReducedMotion();
  const shouldPulse = pulse && !reduceMotion;
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (!scrollToId) {
      trackInitiateCheckout();
      return;
    }
    const target = document.getElementById(scrollToId);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({
      behavior: reduceMotion ? 'auto' : 'smooth',
      block: 'start'
    });
  };
  return <div className="flex w-full flex-col items-center" data-id="element-21" data-mp="35xflv08vct74">
      <motion.a href={scrollToId ? `#${scrollToId}` : CHECKOUT_URL} onClick={handleClick} animate={shouldPulse ? {
      scale: [1, 1.025, 1]
    } : undefined} transition={shouldPulse ? {
      duration: 2.4,
      ease: 'easeInOut',
      repeat: Infinity
    } : undefined} className="font-display group inline-flex w-full max-w-2xl items-center justify-center gap-3 rounded-lg bg-accent px-5 py-4 text-center text-xl font-extrabold uppercase tracking-wide text-zinc-950 shadow-lg shadow-accent/20 transition-colors duration-150 ease-out hover:bg-accent-hover focus:outline-none focus-visible:ring-4 focus-visible:ring-accent/40 md:px-6 md:py-5 md:text-2xl" data-id="element-22" data-mp="35yz3ova6bcb0">
        <SparklesIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-23" data-mp="6iamvq35407p" />
        <span data-id="element-24" data-mp="bh3wv8j7x934">{children}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-25" data-mp="bi6ppm03pllo" />
      </motion.a>
      {note && <p className="mt-4 text-center text-sm text-zinc-400 md:text-base" data-id="element-26" data-mp="3mxgw8h530veg">{note}</p>}
    </div>;
}